import { TFormikError } from "../components/shared/ui/form-elements/FormikElements";

export const cleanErrorMsg = (label: TFormikError): TFormikError => {
  if (typeof label === "string") {
    let parts = label.split("invalid_grant:");
    if (parts.length === 1) {
      return label;
    }
    parts.shift();
    return parts.join("|");
  }
  return label;
};
